export const WEEK_WISE = 'WEEK_WISE'
export const DAY_WISE = 'DAY_WISE'
